var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"plugin_preview_style iframe_framework",attrs:{"src":_vm.viewUrl,"frameborder":"0","height":_vm.iframeHeight,"width":"1000px"}})}
var staticRenderFns = []

export { render, staticRenderFns }